import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api("/auth/session", { method: "POST", body: JSON.stringify({ session_id: sessionId }) })
      .then((user) => {
        window.history.replaceState(null, "", window.location.pathname);
        setUser(user);
        navigate("/posts", { replace: true, state: { user } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-white" data-testid="auth-callback-loading">
      <img src={LOGO_URL} alt="نابو" className="h-20 w-20 animate-pulse rounded-2xl border border-gold/40" />
      <p className="font-tajawal text-muted-foreground">جارٍ تسجيل الدخول...</p>
    </div>
  );
}
